module.exports = __webpack_public_path__ + "static/media/coalesse-1.18fa7850.jpg";